import { UserRole } from '../../store/types/context';

export const path = "/areas";
export { default as Component } from './Area';
export const roles = [UserRole.Admin]
